import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bs-modal"
export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element, { backdrop: 'static', keyboard: true })
    this.handleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.handleEscape, true)
    this.modal.show()
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape, true)
    this.modal.hide()
  }

  dismiss(e) {
    if (e.detail.success) this.modal.hide();
  }

  handleEscape(event) {
    if (event.key !== 'Escape') return

    const openModals = Array.from(document.querySelectorAll('.modal.show'))
    const topModal = openModals[openModals.length - 1]

    if (topModal !== this.element) return

    event.preventDefault()
    event.stopPropagation()
    this.modal.hide()
  }
}
